import { dcAsync, dcFactory } from '@deleteagency/dc';
import onMapsReady from './js/load-locrating-maps-script';

dcFactory.register(dcAsync(() => import('./js/schools-map.component'), 'schools-map'));

export { onMapsReady };
